import { render, staticRenderFns } from "./FolderAssignModal.vue?vue&type=template&id=4d089ada&scoped=true&"
import script from "./FolderAssignModal.vue?vue&type=script&lang=js&"
export * from "./FolderAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./FolderAssignModal.vue?vue&type=style&index=0&id=4d089ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d089ada",
  null
  
)

export default component.exports